import { ComponentKey } from 'enums/componentKey';
import { LegalEntityFormFieldNames } from 'features/new-actor/enums/legalEntityFormFieldNames';
import { LegalEntityFinancialsFormValues } from 'features/new-actor/types/optim/legalEntityFinancialsFormValues';
import { InputsConfig } from 'types/form/inputsConfig';

// Nested under `financials` in the legal entity form values.
const fieldName = (field: keyof LegalEntityFinancialsFormValues) =>
  `${LegalEntityFormFieldNames.Financials}.${field}`;

export const legalEntityFinancialsInputsConfig: InputsConfig<keyof LegalEntityFinancialsFormValues> =
{
  revenue: {
    componentKey: ComponentKey.InputWithUnit,
    name: fieldName('revenue'),
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.LABELS.REVENUE',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.PLACEHOLDERS.REVENUE',
    unit: '€',
    min: 0,
    groupThousands: true
  },
  fiscalYearEnd: {
    componentKey: ComponentKey.InputText,
    name: fieldName('fiscalYearEnd'),
    type: 'date',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.LABELS.FISCAL_YEAR_END',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.PLACEHOLDERS.FISCAL_YEAR_END'
  },
  employeesCount: {
    componentKey: ComponentKey.InputText,
    name: fieldName('employeesCount'),
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.LABELS.EMPLOYEES_COUNT',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.FINANCIALS.PLACEHOLDERS.EMPLOYEES_COUNT',
    min: 0,
    step: 1
  },
};
